var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.381,
    height: 24.93,
    viewBox: "0 0 52.381 24.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e4f1ef;stroke:#20bead;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.211 -42.117)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.257,15.24H12.545c-1.013,0-1.835,1.432-1.835,3.2v13.6c0,1.767.822,3.2,1.835,3.2h3.069l2.064,3.479,2.207-3.479H60.257c1.013,0,1.835-1.432,1.835-3.2v-13.6c0-1.767-.822-3.2-1.835-3.2Z",
    transform: "translate(6 27.377)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.5f93230642107464e67302e09afb7866.svg";
export { ForwardRef as ReactComponent };